import { updateItems } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-3 h-3 rounded-full bg-accent-500 animate-pulse"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">实时快讯</h2>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300/60"></div>

          <div className="space-y-5">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-10">
                <div className={`absolute left-[15px] top-2 w-2.5 h-2.5 rounded-full border-2 ${
                  item.tag === '突发'
                    ? 'bg-primary-500 border-primary-200'
                    : item.tag === '实锤'
                    ? 'bg-accent-500 border-accent-200'
                    : 'bg-secondary-400 border-secondary-200'
                }`}></div>

                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/60 p-4 hover:border-primary-200/50 transition-all cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.time}</span>
                    <span className={`text-xs font-semibold px-1.5 py-0.5 rounded whitespace-nowrap ${
                      item.tag === '突发'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '实锤'
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}